<template>
  <div>
    <v-btn
      rounded="lg"
      color="error"
      prepend-icon="mdi-delete"
      block
      @click="open = true"
      >Agentur löschen</v-btn
    >

    <v-dialog v-model="open" max-width="640">
      <v-card>
        <v-card-title>Agentur löschen</v-card-title>
        <v-card-text>
          <div class="mb-4">
            <div class="text-caption mb-1">Zu löschende Agentur</div>
            <code class="text-body-2">{{ agency?._id }}</code>
          </div>
          <v-text-field
            v-model="confirmText"
            label="Gib DELETE zur Bestätigung ein"
            placeholder="DELETE"
            :disabled="loading"
            required
          />
          <v-switch
            v-model="dryRun"
            :disabled="loading"
            label="Trockenlauf (nur Zähler anzeigen)"
          />

          <v-alert v-if="error" type="error" class="mt-2" density="compact">{{
            error
          }}</v-alert>
          <v-alert
            v-if="success"
            type="success"
            class="mt-2"
            density="compact"
            >{{ success }}</v-alert
          >
          <pre v-if="result" class="result-pre mt-2">{{ result }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="resetAndClose" :disabled="loading"
            >Schließen</v-btn
          >
          <v-btn
            color="error"
            :loading="loading"
            :disabled="confirmText !== 'DELETE'"
            @click="runDelete"
            >{{ dryRun ? "Trockenlauf starten" : "Agentur löschen" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apiClient from "../../plugins/axios";

export default {
  name: "DeleteAgency",
  props: {
    agency: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      dryRun: true,
      confirmText: "",
      loading: false,
      error: "",
      success: "",
      result: "",
    };
  },
  methods: {
    resetAndClose() {
      this.open = false;
      this.dryRun = true;
      this.confirmText = "";
      this.loading = false;
      this.error = "";
      this.success = "";
      this.result = "";
    },
    async runDelete() {
      this.error = "";
      this.success = "";
      this.result = "";
      if (!this.agency?._id) {
        this.error = "Fehlende Agentur-ID";
        return;
      }
      try {
        this.loading = true;
        const payload = {
          agencyId: this.agency._id,
          dryRun: this.dryRun,
        };
        const { data } = await apiClient.post("/agency/delete", payload);
        this.result = JSON.stringify(data, null, 2);
        this.success = this.dryRun ? "Trockenlauf abgeschlossen." : "Agentur gelöscht.";
      } catch (e) {
        this.error = e?.response?.data?.error || e?.message || "Unbekannter Fehler";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.result-pre {
  max-height: 300px;
  overflow: auto;
  background: #0a0a0a;
  color: #e5e7eb;
  padding: 8px;
  border-radius: 8px;
}
</style>
